import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SettingState {
  notification?: {
    [prop: string]: {
      email?: boolean;
      app?: boolean;
      push?: boolean;
    };
  };
  sessionTimeout?: string;
  loaded: boolean;
}

const initialState: SettingState = {
  loaded: false,
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    fetchSetting(state, action: PayloadAction<SettingState>) {
      state.notification = action.payload.notification;
      state.sessionTimeout = action.payload.sessionTimeout;
      state.loaded = true;
    },
  },
});

export const { fetchSetting } = settingSlice.actions;

export default settingSlice.reducer;
